import { BaseView } from '../../../shared/utils/baseComponent'
import css from './error.styles.scss'
import template from './error.template.pug'

class ErrorController extends BaseView {
  constructor($element, $stateParams) {
    'ngInject'
    super($element)
    Object.assign(this, { $stateParams })
  }

  $onInit() {
    this.code = this.$stateParams.code
  }
}

export const errorComponent = {
  controller: ErrorController,
  template: template({ css }),
}



// WEBPACK FOOTER //
// ./app/errors/containers/error/error.component.js